import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallbackExperiment } from "@million/lint/runtime";
import { Core } from "@faire/design-tokens";
import { BaseFiniteScrollCarousel } from "@faire/retailer-visitor-shared/components/Carousel/FiniteScrollCarousel/BaseFiniteScrollCarousel";
import { FilterToggle } from "@faire/retailer-visitor-shared/components/Filters/__internal__/FilterToggle";
import { getMultipleOptionalSelectionsFilters, getSortedFilterSections, getToggleFilters, selectIfSelectedAllSubOptions, syncToggleFilters, updateAllFilterKeys } from "@faire/retailer-visitor-shared/components/Filters/FilterUtils";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingMillionLintFiltersOptimization } from "@faire/retailer-visitor-shared/settings/useSettingMillionLintFiltersOptimization";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackLoggedOutRetailersFilterPillRowView } from "@faire/web-api--source/events/loggedOutRetailers/view/filterPillRow";
import { trackRetailersFilterInteraction } from "@faire/web-api--source/events/retailers/actionUnknown/filterInteraction";
import { trackRetailersFilterClickedClick } from "@faire/web-api--source/events/retailers/click/filterClicked";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import styled, { css } from "styled-components";
export var ToggleFilterRow = function(param) {
    var name = param.name, className = param.className, _param_wrap = param.wrap, wrap = _param_wrap === void 0 ? false : _param_wrap, shouldShowButtons = param.shouldShowButtons;
    var _elementRef_current;
    var shouldMemoMillionLint = useSettingMillionLintFiltersOptimization();
    var _useFilterStore = useFilterStore([
        "filterSections",
        "isNewFilterSelected"
    ]), _useFilterStore_data = _useFilterStore.data, filterSections = _useFilterStore_data.filterSections, isNewFilterSelected = _useFilterStore_data.isNewFilterSelected, setFilterState = _useFilterStore.setFilterState;
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var headerHeight = useTopOfPageContent().headerHeight;
    var sortedFilterSections = getSortedFilterSections(filterSections, false);
    var toggleFilters = getToggleFilters(sortedFilterSections);
    var multipleOptionalSelectionsFilters = getMultipleOptionalSelectionsFilters(filterSections);
    var location = useLocation();
    var viewRef = useDoActionWhenVisible(function() {
        var joinedFilterKeys = toggleFilters.concat(multipleOptionalSelectionsFilters).flatMap(function(section) {
            return section.options.map(function(option) {
                return option.key;
            });
        }).join(";");
        trackLoggedOutRetailersFilterPillRowView(joinedFilterKeys, location.pathname + location.search);
    });
    var scrollToResults = useCallback(function() {
        var _window_scrollTo;
        var window = getWindowOrThrow();
        var rowHeight = isDesktopAndAbove ? 64 : 56;
        var element = getDocumentOrThrow().getElementById("search-page-results-wrapper");
        var _element_getBoundingClientRect_top;
        var elementPos = (_element_getBoundingClientRect_top = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) !== null && _element_getBoundingClientRect_top !== void 0 ? _element_getBoundingClientRect_top : 0;
        var offsetPos = elementPos + window.scrollY - headerHeight - rowHeight;
        (_window_scrollTo = window.scrollTo) === null || _window_scrollTo === void 0 ? void 0 : _window_scrollTo.call(window, {
            top: offsetPos,
            behavior: "smooth"
        });
    }, [
        headerHeight,
        isDesktopAndAbove
    ]);
    var handleFilterSelected = useCallbackExperiment(function(section, filterKey, value) {
        trackRetailersFilterClickedClick(name, filterKey);
        trackRetailersFilterInteraction(name, wrap ? "toggle_filter_click_modal" : "toggle_filter_click_bar", filterKey);
        if (shouldMemoMillionLint) {
            setFilterState(function(currentState) {
                var sectionsUpdated = updateAllFilterKeys(currentState.filterSections, filterKey, value);
                syncToggleFilters(section, sectionsUpdated);
                if (section.field_name === IFilterSection.FieldName.TOP_CATEGORY_PILLS) {
                    var _currentState_filterSections_find;
                    (_currentState_filterSections_find = currentState.filterSections.find(function(s) {
                        return s.field_name === IFilterSection.FieldName.CATEGORY;
                    })) === null || _currentState_filterSections_find === void 0 ? void 0 : _currentState_filterSections_find.options.forEach(selectIfSelectedAllSubOptions);
                }
                return _object_spread_props(_object_spread({}, currentState), {
                    filterSections: _to_consumable_array(sectionsUpdated),
                    isNewFilterSelected: true
                });
            });
        } else {
            var sectionsUpdated = updateAllFilterKeys(filterSections, filterKey, value);
            syncToggleFilters(section, sectionsUpdated);
            if (section.field_name === IFilterSection.FieldName.TOP_CATEGORY_PILLS) {
                var _filterSections_find;
                (_filterSections_find = filterSections.find(function(s) {
                    return s.field_name === IFilterSection.FieldName.CATEGORY;
                })) === null || _filterSections_find === void 0 ? void 0 : _filterSections_find.options.forEach(selectIfSelectedAllSubOptions);
            }
            setFilterState(function(currentState) {
                return _object_spread_props(_object_spread({}, currentState), {
                    filterSections: _to_consumable_array(sectionsUpdated),
                    isNewFilterSelected: true
                });
            });
        }
        if (!isLoggedInRetailerOrBrandPreview()) {
            scrollToResults();
        }
    }, [
        name,
        scrollToResults,
        setFilterState,
        wrap
    ], shouldMemoMillionLint);
    var renderToggleFilters = useCallback(function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                toggleFilters.map(function(filterSection) {
                    return /*#__PURE__*/ _jsx(FilterToggle, {
                        section: filterSection,
                        onChange: handleFilterSelected,
                        disabled: isNewFilterSelected
                    }, "".concat(filterSection.display_name));
                }),
                multipleOptionalSelectionsFilters.map(function(filterSection) {
                    return filterSection.options.map(function(option) {
                        return /*#__PURE__*/ _jsx(FilterToggle, {
                            section: IFilterSection.build(_object_spread_props(_object_spread({}, filterSection), {
                                display_name: option.display_name,
                                options: [
                                    option
                                ]
                            })),
                            onChange: handleFilterSelected,
                            disabled: isNewFilterSelected
                        }, "".concat(option.key));
                    });
                })
            ]
        });
    }, [
        isNewFilterSelected,
        toggleFilters,
        multipleOptionalSelectionsFilters,
        handleFilterSelected
    ]);
    var _React_useState = _sliced_to_array(React.useState(false), 2), shouldHideRightButton = _React_useState[0], setShouldHideRightButton = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(true), 2), shouldHideLeftButton = _React_useState1[0], setShouldHideLeftButton = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(false), 2), isOverflow = _React_useState2[0], setIsOverflow = _React_useState2[1];
    var elementRef = React.useRef(null);
    React.useEffect(function() {
        if (elementRef.current) {
            setIsOverflow(elementRef.current.scrollWidth > Math.round(elementRef.current.getBoundingClientRect().width));
        } else {
            setIsOverflow(false);
        }
    }, [
        elementRef,
        (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.scrollWidth
    ]);
    if (sortedFilterSections.length > 0 && toggleFilters.length === 0 && multipleOptionalSelectionsFilters.length === 0) {
        return null;
    }
    if (sortedFilterSections.length === 0) {
        return /*#__PURE__*/ _jsx(Row, {
            "data-test-id": "toggle-filter-row-placeholder",
            children: Array.from({
                length: 2
            }, function(_value, index) {
                return /*#__PURE__*/ _jsx(SpacedLoadingSkeleton, {
                    width: "140px",
                    height: "40px",
                    borderRadius: "40px"
                }, "toggleFilterPlaceholder_".concat(index));
            })
        });
    }
    if (wrap || !shouldShowButtons || !isDesktopAndAbove) {
        return /*#__PURE__*/ _jsx(Wrapper, {
            className: className,
            $isWrap: wrap,
            ref: viewRef,
            children: renderToggleFilters()
        });
    }
    return /*#__PURE__*/ _jsx(Wrapper, {
        $isWrap: false,
        className: className,
        ref: viewRef,
        children: /*#__PURE__*/ _jsx(StyledBaseFiniteScrollCarousel, {
            forwardRef: elementRef,
            name: name,
            shouldHideRightButton: !isOverflow || shouldHideRightButton,
            shouldHideLeftButton: !isOverflow || shouldHideLeftButton,
            onRightEndReached: function(isRightEndReached) {
                setShouldHideRightButton(isRightEndReached);
            },
            onLeftEndReached: function(isLeftEndReached) {
                setShouldHideLeftButton(isLeftEndReached);
            },
            chevronButtonDimension: {
                width: 15,
                height: 9
            },
            useIconArrows: true,
            children: /*#__PURE__*/ _jsxs(Row, {
                gap: "1x",
                children: [
                    toggleFilters.map(function(filterSection) {
                        return /*#__PURE__*/ _jsx(FilterToggle, {
                            section: filterSection,
                            onChange: handleFilterSelected,
                            disabled: isNewFilterSelected
                        }, "".concat(filterSection.display_name));
                    }),
                    multipleOptionalSelectionsFilters.map(function(filterSection) {
                        return filterSection.options.map(function(option) {
                            return /*#__PURE__*/ _jsx(FilterToggle, {
                                section: IFilterSection.build(_object_spread_props(_object_spread({}, filterSection), {
                                    display_name: option.display_name,
                                    options: [
                                        option
                                    ]
                                })),
                                onChange: handleFilterSelected,
                                disabled: isNewFilterSelected
                            }, "".concat(option.key));
                        });
                    })
                ]
            })
        })
    });
};
// eslint-disable-next-line @faire/prefer-slate-attrs -- false alarm (display: none refers to scrollbar)
var Wrapper = styled(Row).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-84a18f44-0"
})([
    "-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}",
    ""
], function(props) {
    return props.$isWrap ? css([
        "flex-wrap:wrap;"
    ]) : css([
        "overflow-x:auto;"
    ]);
});
var SpacedLoadingSkeleton = styled(LoadingSkeleton).withConfig({
    componentId: "sc-84a18f44-1"
})([
    "margin-right:",
    ";"
], getSpacing("1x"));
var StyledBaseFiniteScrollCarousel = styled(BaseFiniteScrollCarousel.BaseFiniteScrollCarousel).withConfig({
    componentId: "sc-84a18f44-2"
})([
    "display:flex;flex-direction:row;top:0;width:100%;padding:0;",
    ",",
    "{color:",
    ";width:30px;height:30px;",
    "{color:",
    ";&:hover{color:",
    ";}}",
    "{display:none;}}",
    "{left:50px;background-color:",
    ";border-radius:0px 50% 50% 0px;}",
    "{right:50px;background-color:",
    ";border-radius:50% 0px 0px 50%;}",
    "{align-items:flex-start;width:100%;}"
], BaseFiniteScrollCarousel.Previous, BaseFiniteScrollCarousel.Next, Core.text.enabled, responsiveMediaQueries.canHover, Core.text.subdued, Core.text.hover, responsiveMediaQueries.tabletAndBelow, BaseFiniteScrollCarousel.PreviousIcon, Core.icon.inverse, BaseFiniteScrollCarousel.NextIcon, Core.icon.inverse, BaseFiniteScrollCarousel.Scrollable);
